import React from "react";
import { graphql, StaticQuery } from "gatsby";

import styles from "./Copyright.module.scss";
import classNames from "classnames/bind";

export default function Copyright(props) {
    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        props.className
    );

    return (
        <StaticQuery
            query={graphql`
                query CopyrightMeta {
                    site {
                        siteMetadata {
                            copyright
                        }
                    }
                }
            `}

            render={data => (
                <p className={classes}>{data.site.siteMetadata.copyright}</p>
            )}
        />
    )
}